import { CommonModule } from '@angular/common';
import {
    Component,
    EventEmitter,
    OnInit,
    Output,
    ChangeDetectionStrategy
} from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { ClientService } from '../../../../core/services/client.service';
import { Client } from '../../../../domain/models';

@Component({
    selector: 'app-age',
    templateUrl: './age.component.html',
    styleUrls: ['./age.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        TranslocoModule,
        MatIcon,
        FlexLayoutModule,
        MatButtonModule
    ]
})
export class AgeComponent implements OnInit {
    @Output() age = new EventEmitter<number>();
    @Output() back = new EventEmitter<void>();
    showError = false;
    showMessageHtml = false;
    messageHtml = '';
    client: Client | undefined;

    constructor(private readonly _client: ClientService) {}

    currentSelection = -1;

    ngOnInit() {
        this._client.latest.subscribe((client) => {
            this.client = client;
        });
    }

    ageRangeChosen(selection: number): void {
        this.currentSelection = selection;
        if (selection === 1 && this.client?.signUpHowOldMessage1Html) {
            this.messageHtml = this.client?.signUpHowOldMessage1Html;
            this.showMessageHtml = true;
        } else if (selection === 2 && this.client?.signUpHowOldMessage2Html) {
            this.messageHtml = this.client?.signUpHowOldMessage2Html;
            this.showMessageHtml = true;
        } else if (selection === 3 && this.client?.signUpHowOldMessage3Html) {
            this.messageHtml = this.client?.signUpHowOldMessage3Html;
            this.showMessageHtml = true;
        } else this.age.next(selection);
    }

    continue(): void {
        this.age.next(this.currentSelection);
    }

    goBack(): void {
        this.back.next();
    }

    goBackPrevious(): void {
        this.showMessageHtml = false;
    }
}
